<template>
    <app-overlay-loader v-if="preloader"/>
    <form v-else ref="form" data-url="/cost-settings" class="mb-0" :class="{'loading-opacity': preloader}">
        <div class="form-group row align-items-center">
            <label for="harbor_maintenance_fee" class="col-lg-3 col-xl-3 mb-lg-0">
                {{ $t('Harbor Maintenance Fee') }}
            </label>
            <div class="col-lg-8 col-xl-8">
                <app-input 
                    type="number"
                    v-model="cost.harbor_maintenance_fee.value"
                    :placeholder="'Harbor Maintenance Fee'"
                    :required="true"
                />
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label for="merchandise_processing_fee" class="col-lg-3 col-xl-3 mb-lg-0">
                {{ $t('Merchandise Processing Fee') }}
            </label>
            <div class="col-lg-8 col-xl-8">
                <app-input 
                    type="number"
                    v-model="cost.merchandise_processing_fee.value"
                    :placeholder="'Merchandise Processing Fee'"
                    :required="true"
                />
            </div>
        </div>

         <div class="form-group row align-items-center">
            <label for="insurance" class="col-lg-3 col-xl-3 mb-lg-0">
                {{ $t('Insurance') }}
            </label>
            <div class="col-lg-8 col-xl-8">
                <app-input 
                    type="number"
                    v-model="cost.insurance.value"
                    :placeholder="'Insurance'"
                    :required="true"
                />
            </div>
        </div>

        <div class="mt-5 action-buttons">
            <button class="btn btn-primary mr-2" @click.prevent="submit">
                {{ $t('save') }}
            </button>
        </div>
    </form>
</template>

<script>
    import {FormMixin} from "../../../../core/mixins/form/FormMixin";
    import * as actions from "../../../Config/ApiUrl";

    export default {
        name: "index.vue",
        mixins: [FormMixin],
        data() {
            return {
                preloader: false,
                cost: {
                    harbor_maintenance_fee : {id : null, value : null},
                    merchandise_processing_fee : {id : null, value : null},
                    insurance : {id : null, value : null},
                },
                showError: false,
            }
        },
        created() {
            this.getData();
        },
        methods: {

            beforeSubmit() {
                this.preloader = true;
            },
            submit() {
                this.save(this.cost);
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterSuccess(res) {
                console.log(res);
                
                this.$toastr.s(res.data.message);
            },
            afterError(res) {
                this.showError = true;
                this.$toastr.e(res.data.message);
            },
            getData() {
                this.preloader = true;
                let url = actions.GET_COST_SETTINGS;
                this.axiosGet(url).then(response => {
                    if (response.data) {
                        const data = response.data;
                        data.forEach(element => {
                            if (element.name === 'harbor_maintenance_fee') {
                                this.cost.harbor_maintenance_fee.value = element.value;
                                this.cost.harbor_maintenance_fee.id = element.id;
                            }
                            if (element.name === 'merchandise_processing_fee') {
                                this.cost.merchandise_processing_fee.value = element.value;
                                this.cost.merchandise_processing_fee.id = element.id;
                            }
                            if (element.name === 'insurance') {
                                this.cost.insurance.value = element.value;
                                this.cost.insurance.id = element.id;
                            }
                        });
                    }
                }).catch(({response}) => {

                }).finally(() => {
                    this.preloader = false;
                });
            }
        }
    }
</script>
